import React from "react";
import "./Contact.css";
import { Email } from "../../components/Email/Email";
import Animate from "../../components/Animate/Animate";
import { IconContext } from "react-icons";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import "../../App.css";

function Contact() {
  return (
    <>
      <div className='contact-container'>
        <div className='contact-text-div'>
          <Animate>
            <h1>Get in touch</h1>
            <div className='contact-text'>
              <p>
                If you wanna get in touch, talk to me about a project
                collaboration or just say hi,
                <br />
                fill up the form below or send an email to{" "}
                <span style={{ fontWeight: "bold", color: "#cacaca" }}>
                  eda.twinkle@gmail.com{" "}
                </span>
                and ~let's talk.
              </p>
            </div>
            <Email />
          </Animate>
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          left: "2%",
          top: "50%",
        }}
        className='navigator-about'>
        <Link to='/' className='moveArrowRight'>
          <IconContext.Provider
            value={{
              color: "#7a7a7a",
              size: "3rem",
            }}>
            <div className='hover-text-div'>
              <IoIosArrowDown style={{ transform: "rotate(90deg)" }} />
              <p className='hover-text'>About</p>
            </div>
          </IconContext.Provider>
        </Link>
      </div>
      <div
        style={{
          position: "absolute",
          right: "2%",
          top: "50%",
        }}
        className='navigator-about'>
        <Link to='/skills' className='moveArrowLeft'>
          <IconContext.Provider
            value={{
              color: "#7a7a7a",
              size: "3rem",
            }}>
            <div className='hover-text-div'>
              <p className='hover-text'>Skills</p>
              <IoIosArrowDown style={{ transform: "rotate(-90deg)" }} />
            </div>
          </IconContext.Provider>
        </Link>
      </div>
    </>
  );
}

export default Contact;
